import IconBackground from '$tablet-app/src/app/components/IconBackground';
import Row from '$tablet-app/src/app/components/Row';
import Spacer from '$tablet-app/src/app/components/Spacer';
import { Switch } from '$tablet-app/src/app/components/Switch/Switch';
import Text from '$tablet-app/src/app/components/Text';
import {
  MealAvoidance,
  MealAvoidanceCategory,
  MealAvoidanceDegree,
  MealAvoidanceOptionUIData,
} from '$tablet-app/src/app/recipes/types';
import { palette } from '$tablet-app/src/app/theme';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import React, { FC } from 'react';
import { StyleSheet } from 'react-native';
import { Switch as Toggle } from 'react-native-elements';
import styled from 'styled-components/native';

interface Props extends MealAvoidanceOptionUIData {
  onPress: (category: MealAvoidanceCategory) => void;
  onSwitchSelection: (avoidance: MealAvoidance) => void;
}

const AvoidancePreferenceRow: FC<Props> = (props) => {
  const {
    category,
    degree,
    active,
    icon,
    iconColor,
    color,
    onPress,
    onSwitchSelection,
  } = props;

  const handleOnPress = () => onPress(category);
  const onChangeSelection = (select: string) =>
    onSwitchSelection({
      degree: parseInt(select),
      category,
    });

  return (
    <Container>
      <TopRow onPress={handleOnPress}>
        <Row alignItems="center">
          <IconBackground color={color}>
            <FontAwesomeIcon icon={icon} color={iconColor} size={28} />
          </IconBackground>
          <Spacer width="24px" />
          <Text weight="semibold">{category}</Text>
        </Row>

        <Toggle
          value={!!active}
          onChange={handleOnPress}
          color={palette.primary_700}
        />
      </TopRow>

      {active && degree !== undefined ? (
        <BottomSection>
          <Switch
            value={degree.toString()}
            onValueChange={onChangeSelection}
            options={SelectionOptions}
            buttonWidth={250}
            buttonStyle={slider_styles.button}
          />
        </BottomSection>
      ) : null}

      {/* <BottomSection></BottomSection> */}
    </Container>
  );
};

const Container = styled.View`
  padding: 25px;
  width: 600px;
  border-bottom-width: 1px;
  border-bottom-color: lightgrey;
`;

const TopRow = styled.TouchableOpacity`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const BottomSection = styled.View`
  margin-top: 16px;
  align-items: center;
`;

const slider_styles = StyleSheet.create({
  button: {
    height: 60,
  },
});

const SelectionOptions = [
  {
    id: MealAvoidanceDegree.ALL_OF_THE_TIME.toString(),
    label: 'Avoid all the time',
  },
  {
    id: MealAvoidanceDegree.SOME_OF_THE_TIME.toString(),
    label: 'Avoid some of the time',
  },
];

export default AvoidancePreferenceRow;
